import React from "react";
import classNames from "classnames";
import { formatExactDateTooltipLines, timeAgo } from "@helpers/date";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import styles from "./ActivityTimeline.module.scss";

interface ActivityTimelineProps {
    children: React.ReactNode;
    className?: string;
    "data-testid"?: string;
}

export const ActivityTimeline: React.FC<ActivityTimelineProps> = ({
    children,
    className,
    "data-testid": dataTestId,
}) => (
    <ul
        className={classNames(styles.timeline, className)}
        data-testid={dataTestId}
    >
        {children}
    </ul>
);

interface ActivityTimelineLogProps {
    timestamp: Date | string;
    children: React.ReactNode;
    details?: React.ReactNode;
    "data-testid"?: string;
}

export const ActivityTimelineLog: React.FC<ActivityTimelineLogProps> = ({
    timestamp,
    children,
    details,
    "data-testid": dataTestId,
}) => {
    const { utcLine, localLine } = formatExactDateTooltipLines(timestamp);
    return (
        <li className={styles.log} data-testid={dataTestId}>
            <div className={styles.content}>{children}</div>
            <aside className={styles.timestamp}>
                {" "}
                <Tooltip
                    content={
                        <>
                            {utcLine}
                            <br />
                            {localLine}
                        </>
                    }
                >
                    <span tabIndex={0}>{timeAgo(timestamp)}</span>
                </Tooltip>
            </aside>
            {details ? <div className={styles.details}>{details}</div> : null}
        </li>
    );
};
